module.exports = __webpack_public_path__ + "static/show_time_and_locations_on_separate_lines_example-41b232ec3350cb651e302505f6404a08.png";